import Default from './default';
import Mobile from './mobile';

export default { Default, Mobile };
